import type { BaseResponse } from "~/types/Data/Common/APIs";

export default function useSearchProducts() {
  const recentSearches = useLocalStorage<string[]>("recentSearches", []);
  const suggestions = ref<string[]>([]);

  const getSearchData = async (value: string) => {
    const normalizedTerms = normalizeSearchTerms(value as string);
    const searchQuery = normalizedTerms.join(" ");

    const { res } = await useApi<BaseResponse<string[]>>(
      `/api/v1/products-autocomplete?search=${searchQuery}`,
    );
    suggestions.value = res?.data ?? [];
  };

  const addToRecentSearches = (title: string) => {
    if (!recentSearches.value.includes(title)) {
      recentSearches.value.unshift(title);
    }
  };

  const removeFromRecentSearches = (title: string) => {
    recentSearches.value = recentSearches.value.filter((i) => i !== title);
  };

  const clearAllSearches = () => {
    recentSearches.value = [];
  };

  const normalizeSearchTerms = (term: string) => {
    return term.toLowerCase().split(/\s+/).filter(Boolean);
  };

  return {
    suggestions,
    recentSearches,
    getSearchData,
    addToRecentSearches,
    removeFromRecentSearches,
    clearAllSearches,
  };
}
